import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notificationLoading: false,
  notifications: null,
  unreadCount: 0,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationLoading: (state, action) => {
      state.notificationLoading = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    resetNotificationSlice: (state) => {
      state.notifications = null;
      state.unreadCount = 0;
      state.notificationLoading = false;
    },
  },
});

export const { setNotificationLoading, setNotifications, setUnreadCount, resetNotificationSlice } = notificationSlice.actions;
export default notificationSlice.reducer;
